import { IReducer } from './moduleReducerRegistry';
import { InsightValue, TimeFrameValue } from 'common/types';
import { config } from 'config/config';
import { IFilterState, ITabProperties } from 'appRedux/createStore';
import { FilterActionTypes } from 'appRedux/actions/filterCommandCreator';
import { IFilterType, OrderByEnum } from 'common/common';
import {
  EXPLORE_DEFAULT_INSIGHT_FALLBACK,
  EXPLORE_DEFAULT_TIMEFRAME_FALLBACK,
} from 'config/exploreDefaultFallbacks';

// Static starting values (applicationConfigurations is not loaded yet at store
// creation, and RESET_FILTERS must stay a safe, always-allowed state for free
// users). Explore's casino-entry reset (MapStats) then applies the configured
// exploreDefault* values via lib/exploreDefaults.
const defaultFilters: ITabProperties = {
  timeframe: EXPLORE_DEFAULT_TIMEFRAME_FALLBACK as TimeFrameValue,
  insight: EXPLORE_DEFAULT_INSIGHT_FALLBACK as InsightValue, // Changed from 'spins' — free subscriptions now start with RTP
  orderby: OrderByEnum.Desc,
  denominations: config.denom,
  advancedViewInsights: [
    'pop',
    'return',
    'spins', 
    'jackpot_value',
    'money_played',
  ] as InsightValue[],
};

export const defaultFilterValues: { [key in keyof IFilterState]: ITabProperties } = {
  leaderboard: { ...defaultFilters },
  jackpot: { ...defaultFilters, insight: 'jackpot_value' as InsightValue },
  myplay: { ...defaultFilters },
  graphfilter: { ...defaultFilters },
  mapfilter: { ...defaultFilters },
  snapfilter: { ...defaultFilters },
  main: { ...defaultFilters },
  hottestSlots: { ...defaultFilters },
};

export const filterInitialState = {
  ...defaultFilterValues,
};

const resetInitailState = {
  leaderboard: { ...defaultFilters },
  jackpot: { ...defaultFilters, insight: 'jackpot_value' as InsightValue },
  myplay: { ...defaultFilters },
  graphfilter: { ...defaultFilters },
  mapfilter: { ...defaultFilters },
  snapfilter: { ...defaultFilters },
  main: { ...defaultFilters },
  hottestSlots: { ...defaultFilters },
};

export const filtersReducer: IReducer = (draft, action) => {
  switch (action.type) {
    case FilterActionTypes.SET_FILTER_OPTIONS:
      const { id: filterId, filters } = action.state;

      draft.app.persistedState.filterState[filterId as IFilterType] = {
        ...draft.app.persistedState.filterState[filterId as IFilterType],
        ...(filters as ITabProperties),
      };
      break;
    case FilterActionTypes.RESET_FILTERS:
      draft.app.persistedState.filterState = resetInitailState;
      break;
  }
};
